import { Box } from '@mui/material';
import React, { PropsWithChildren } from 'react';

const DetailDataGridContainer: React.FC<PropsWithChildren> = ({ children }) => (
  <Box sx={(theme) => ({ backgroundColor: theme.custom.background.level3, borderRadius: 1, p: { xs: 2, sm: 3 } })}>
    {children}
  </Box>
);

export default DetailDataGridContainer;
